import { createSlice } from '@reduxjs/toolkit'

export const stockpricesSlice = createSlice({
  name: 'stockprices',
  initialState: {
    value: [],
  },
  reducers: {
    updateStockPrices: (state, action) => {
      state.value = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { updateStockPrices } = stockpricesSlice.actions